<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Справочник регионов
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
            size="20"
            color="info"
            class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
            v-model="search"
            color="info"
            outlined
            label="Начните набирать наименование региона"
            class="search-field"
            dense
            style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
          :headers="headers.massive"
          :headers-for-rows="headers.massive"
          :num-cols="headers.countCells"
          :loading-data="loading || getRegionsStatus"
          :data-rows="showingData"
          type-table="grid"
      >
        <template #region1="{row,cell}">
          <div v-html="cell.template(row)"></div>
          <contact-menu :id="row.id" :props-contact="row.contact">
            <template #header-title>
              {{ row.name }}
            </template>
          </contact-menu>
        </template>
        <template #actions="{row}">
          <v-btn class="white__v-btn" @click="authAdOrg(row)">Войти</v-btn>
        </template>
        <template #blocks="{row}">
          <v-btn
              icon
              :disabled="blocking.value"
              :loading="blocking.value && blocking.id === row.id"
              @click="blockRegion(row)"
          >
            <v-icon size="24" :color="checkOnBlock(row) ? 'info' : 'success'">
              {{checkOnBlock(row) ? 'mdi-lock-outline' : 'mdi-lock-open-outline'}}
            </v-icon>
          </v-btn>
        </template>
      </grid-table>
    </wrapper-preview-category>

  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import GridTable from "@/components/GridTable/GridTable";
import ContactMenu from "@/components/Menus/contact-menu";
import config from "@/pages/Admin/configs/region_config";
import {mapActions, mapGetters} from "vuex";
import UserController from "@/controllers/UserController";

export default {
  name: "Regions",
  components: {ContactMenu, GridTable, WrapperPreviewCategory},
  data() {
    return {
      search: '',
      headers: config,
      loading: false,
      blocking: {value: false, id: null},
    }
  },
  computed: {
    ...mapGetters('spr', {
      getRegions: 'getRegions',
      getRegionsStatus: 'getRegionsStatus'
    }),
    showingData() {
      return this.getRegions
          .filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1 || String(el.id).toLowerCase().search(this.search.toLowerCase()) !== -1)
          .sort((a,b) => a.id - b.id)
    }
  },
  created() {
    this.getServerData()
  },
  methods: {
    ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer', changeBlockInfo: 'changeBlockInfo'}),
    ...mapActions('keycloak', {initFakeUser: 'initFakeUser'}),
    ...mapActions('checkFilled', {loadingBlockInfo: 'loadingBlockInfo', getContact: 'getContact'}),
    checkOnBlock(row){
      return row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === 2) &&  row.stageDataBlocks.find(el => el.stageId === 2)?.block === true
    },
    async getServerData() {
      try {
        this.loading = true;
        await this.getRegionsFromServer();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async blockRegion(row){
      this.blocking.value = true;
      this.blocking.id = row.id;
      if (row.stageDataBlocks.length !== 0 && row.stageDataBlocks.find(el => el.stageId === 2) && row.stageDataBlocks.find(el => el.stageId === 2)?.block === true)
      await UserController.unBlock('region', 2, row.id)
          .finally(() => {
            this.blocking.value = false;
            this.blocking.id = null;
          });
      else
        await UserController.setBlock('region', 2, row.id)
            .finally(() => {
              this.blocking.value = false;
              this.blocking.id = null;
            });
    },
    authAdOrg(row){
      this.initFakeUser({
        role: 'REGION_ROLE',
        id: row.id,
        name: row?.name ?? ''
      });
      this.loadingBlockInfo();
      this.getContact('REGION_ROLE');
      this.$router.push({name: 'stage-2'})
    }
  },
}
</script>

<style scoped>

</style>